// =============================================================================
// PAYMENT PAGE
// =============================================================================

import React from 'react';
import { PaymentScreen } from '@/components/Payment/PaymentScreen';
import { SEOHead } from '@/components/SEO';

export const PaymentPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Payment - Alex Finger Consulting"
        description="Complete your payment securely for professional services, courses, or subscriptions."
        keywords={['payment', 'checkout', 'secure payment', 'professional services'].join(', ')}
        canonicalUrl="/payment"
      />
      <PaymentScreen />
    </>
  );
};

export default PaymentPage;
